import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../utils/axiosSetup.js';
import Pagination from '../../layouts/pagination.jsx';
import SendMail from '../../../action/send-mail.jsx';

const EMNotFilled = () => {
    const [getEmployees, setEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [filterText, setFilterText] = useState('');

    const fetchQA = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/em_not_filled?page=${currentPage + 1}`)
            .then(response => {
                setEmployees(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching the employees!", error);
                setEmployees([]);
            });
    };

    useEffect(() => {
        fetchQA(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = getEmployees.filter(
        item => item.name.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">EM Not Filled</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">EM Not Filled</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row emnotWrap">
                    <div className="col-md-3 mb-3">
                        <input className="form-control" id="search_Input" type="text" placeholder="Search employee..." 
                            aria-label="Search employee" value={filterText} 
                            onChange={(event)=>{ setFilterText(event.target.value) }} />
                    </div>
                    <div className="col-md-9 mb-3 text-end">
                        <SendMail url="mail/em_not_filled" />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table notfiledData">                                        
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.filter(item => item.not_filled_dates.length !== 0).map(emp => (
                                                        <tr key={emp.id}>
                                                            <td>{emp.name} (<span className="text-danger">{emp.not_filled_dates}</span>)</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="1">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>
        </>
    );
}

export default EMNotFilled